import { Component, OnInit } from '@angular/core';
import { CARTVIEW, NAVIGATION } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    
})
export class NavbarComponent implements OnInit {

  url: any;
  catall = [];
  catwithsub = [];
  catwithoutsub = [];
  logochange:number = 0;
  uid:any;
  results:any[];
  alert:boolean=false;
  div:boolean=false;
  baseurl:any;
  message:any="CART IS EMPTY";
  newurl:any;
  drop: any;
  constructor(private api: ApiService, private router: Router) {
    
                  //cart work start //
                  this.uid=this.api.uid;
                  console.log("userid"+this.uid); 
                  this.api.getlogin.subscribe(data=>{
                    this.uid=this.api.uid;
                  })
                  if(localStorage.getItem('savya_userInfo'))
                  {
                    this.view();
                  }
                  
                  //cart work end//
          
            this.api.Get(NAVIGATION).then(data => {
              this.catall = data['data'];
            
              this.catall.forEach(element => {
                if (element['subcategory'].length){
                  this.catwithsub.push(element);
                }
                else {
                  this.catwithoutsub.push(element);
                }
                }
              );
             
            });
           
}
ProductsInCart()
{
  let cart=this.api.getCart();
  if(cart)
  {
    return (cart.length);
  }
  else
  {
    return (0);
  }
}
gofilter(value) {
  console.log(value);
  this.router.navigate(['/subsub', value]);
}
  deleteCart(pid)
  {
    this.api.deleteCart(pid);
  }
  view()
  {
      this.api.Get(CARTVIEW+"?user_id="+this.api.uid).then(data=>{
        console.log(data);  
        this.baseurl=data['url']+"/";
        this.results=data['data'];
        this.alert=false;
        this.div=true;
      
      }).catch(d=>{
        if( d.status == 503){
          // this.api.onFail('Your session is expired please login again','Login Again');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
        this.div=false;
        this.alert=true;
        console.log(d);}
      });
  }
ngOnInit() {
  this.api.getlogin.subscribe(data => {
    console.log(+data);
    this.drop=data;
   })
  this.api.Cart.subscribe(data => {
    this.view();
    console.log("changed");
    console.log("getWishSubscribe"+data);
     });
     this.drop=this.api.drop;
}
}
